import { ca } from '@cian/analytics';

/* istanbul ignore next */
export function trackCall(analyticParams: {
  label: string;
  products: Record<string, unknown>;
  page: Record<string, unknown>;
  user: Record<string, unknown>;
}) {
  ca('eventSite', {
    category: 'Phones',
    action: 'Call',
    ...analyticParams,
  });
}
